module.exports = __webpack_public_path__ + "img/thumbnail_BengalTiger_f_albino.d9d7bdad.png";